import React from 'react'
import styles from 'css/Header.module.css'
import { AnimatePresence, motion } from 'framer-motion'
import SettingLayer from 'views/setting/Home'
import AlertLayer from 'views/alert/Alert'
import { BackArrow } from 'components/HeaderComponents'


const Header = ({ title, show, type = "default", left, right, className }) => {

	const variants = { initial: { top: -60 }, animate: { top: 0 } }

	return (
		<>
			<AnimatePresence>
				{show &&
					<motion.header variants={variants} initial="initial" animate="animate" exit="initial" className={`${styles[type]} ${className}`}>
						<div className={styles.left}>{typeof left === "undefined" ? <BackArrow /> : left}</div>
						<div className={styles.title}>{title}</div>
						<div className={styles.right}>{right}</div>
					</motion.header>
				}
			</AnimatePresence>

			<SettingLayer />
			<AlertLayer />
		</>
	)
}

export default Header
